<template>
    <!--    already inside a v-container-->
    <v-main>
        <v-container>
            <div v-if="profiles && profiles.length>5" style="width:100%;height:80px;"></div>

            <v-row v-if="!cardview">
                <v-col cols="12" sm="10" md="10" class="py-0">
                    <v-list class="py-0">
                        <PlayerListItem
                                v-for="p in fprofiles"
                                :profile="p"
                                :checks="creategroup"
                                :checkon="selected.includes(p.partkey)"
                                @selected="emitSelected(p)"
                        />
                    </v-list>
                </v-col>
            </v-row>
            <div v-if="creategroup" style="width:100%;height:80px;" >
                <!--                Spacer for the floating box to show-->
            </div>


            <v-row v-if="cardview">
                <v-col v-for="p in fprofiles" cols="6" sm="4" md="3" >
                    <PlayerCardItem
                                    :profile="p"
                                    :checks="creategroup"
                                    :checkon="selected.includes(p.partkey)"
                                    @selected="emitSelected(p)"/>
                </v-col>
            </v-row>

            <v-dialog v-model="dialog" max-width="450">
                <v-card>
                    <v-card-title class="font-weight-light subtitle-2">Search</v-card-title>
                    <v-card-text>
                        <v-text-field
                                outlined
                                label="Search Profiles"
                                v-model="search"
                                @input="searchAthletes()"
                                :prepend-icon="icons.search"
                        />
                        <v-list>
                            <PlayerListItem v-for="p in searched" :profile="p" @selected="emitSelected(p)"/>
                        </v-list>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn small text @click="dialog=false">
                            cancel
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <div style="position: fixed;bottom:10px;left:10px;z-index:5"
                 v-if="creategroup"
            >
                <v-card color="blue darken-1">
                    <v-card-title class="subtitle-1 pb-0"></v-card-title>
                    <v-card-text>
                    <span class="white--text subtitle-1">{{Object.keys(selected).length}}
                    profiles selected
                    </span>
                    </v-card-text>
                    <v-card-actions>
                        <AddToGroup color="white--text" :keystoadd="selected" @done="handleDone($event)"/>
                        <v-spacer/>
                        <v-btn text small @click="selected=[],setSelectedProfiles(undefined),creategroup=false"
                               class="white--text">Clear
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </div>
        </v-container>
        <div v-if="profiles && profiles.length>5" style="width:100%;position:fixed;top:48px;padding-top:5px;background-color:white;" >
            <v-toolbar-items>
                <v-btn text small v-if="listname==='archived'" @click="getMyAthletes(),listname='active'">
                    <v-icon>mdi-archive-arrow-up-outline</v-icon>
                </v-btn>
                <v-btn text small v-if="listname==='active'" @click="getMyAthletesArchived(),listname='archived'">
                    <v-icon>mdi-archive-outline</v-icon>
                </v-btn>
                <v-btn text small @click="dialog=true" :disabled="dialog">
                    <v-icon>{{icons.search}}</v-icon>
                </v-btn>
                <v-btn text small  @click="creategroup=!creategroup">
                    <v-icon :color="creategroup?'blue':''">mdi-checkbox-marked-outline</v-icon>
                </v-btn>
                <v-btn text small  to="/myathleteslists">
                    <v-icon>{{icons.group}}</v-icon>
                </v-btn>
                <v-btn text small  @click="cardview=!cardview">
                    <v-icon>{{icons.card}}</v-icon>
                </v-btn>
                <v-spacer/>
                <v-menu v-model="menufilter">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                                text small
                                v-bind="attrs"
                                v-on="on"
                        >
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list
                            style="max-height: 80vh"
                            class="overflow-y-auto">
                        <v-list-item
                                v-for="(item, index) in years"
                                :key="index"
                                @click="fltr=item"
                        >
                            <v-list-item-title>{{ item }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-toolbar-items>
            <v-row>
                <v-col cols="12" class="py-0" >
                    <v-list-item v-if="profiles && profiles.length>5">
                        <v-list-item-content>
                            <v-list-item-subtitle>
                                <span class="font-weight-light blue--text text--darken-2">
                                    {{fltr}} | {{listname}} | {{listlength}} Profile<span v-if="listlength!==1">s</span></span>
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>
                                <span class="font-weight-light primary--text ">{{filtermessage}}</span>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action >
                            <v-btn text small @click="Sort('name')">
                                <v-icon v-if="[1,3].includes(sortnameindex) && sorting==='name'" color="blue">
                                    mdi-sort-alphabetical-ascending
                                </v-icon>
                                <v-icon v-else-if="[2,4].includes(sortnameindex) && sorting==='name'" color="blue">
                                    mdi-sort-alphabetical-descending
                                </v-icon>
                                <v-icon v-else color="awesome">mdi-sort-alphabetical-variant</v-icon>
                            </v-btn>
                        </v-list-item-action>
                        <v-list-item-action >
                            <v-btn text small
                                   :disabled="Number.isInteger(fltr)"
                                   @click="Sort('year')">
                                <v-icon v-if="[1].includes(sortyearindex)  && sorting==='year'" color="blue">
                                    mdi-sort-numeric-descending
                                </v-icon>
                                <v-icon v-else-if="[2].includes(sortyearindex)  && sorting==='year'" color="blue">
                                    mdi-sort-numeric-ascending
                                </v-icon>
                                <v-icon v-else color="awesome">mdi-sort-numeric-variant</v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>
                </v-col>
            </v-row>
        </div>
    </v-main>

</template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from 'vuex'
  import draggable from 'vuedraggable'
  import PlayerListItem from "@/views/a4l/playercomponents/PlayerListItem";
  import AddToGroup from "../../components/groups/AddToGroup";
  import PlayerCardItem from "../a4l/PlayerCardItem";


  export default {
    name: "MyAthletesList",
    props: ['activeid', 'disabled', 'autorefreshmobile'],
    components: {PlayerCardItem, AddToGroup, PlayerListItem, draggable},
    data() {
      return {
        checkingin: '000',
        fltr: 'Current',
        menufilter: false,
        fprofiles: undefined,
        submode: undefined,
        title: '',
        mylists: [],
        selected: [],
        list: [],
        activelist: undefined,
        sort: false,
        sortnamearray: [[false, undefined], ['lastname', true], ['lastname', false], ['firstname', true], ['firstname', false]],
        sortnameindex: 0,
        sortyeararray: [[false, undefined], ['gradyear', true], ['gradyear', false]],
        sortyearindex: 0,
        sortnameasc: undefined,
        sortdateasc: undefined,
        sorting: 'name',
        listname: undefined,
        search: '',
        searched: [],
        dialog: false,
        creategroup: false,
        filtermessage: '',
        cardview: false
      }
    },
    computed: {
      ...mapState(['myathletes', 'icons', 'dev', 'selectedprofiles']),
      profiles() {
        return this.myathletes
      },
      years() {
        let ar = []
        if (!this.profiles) return
        this.profiles.forEach(function (p) {
          if (!ar.includes(p.gradyear)) {
            ar.push(p.gradyear)
          }
        })
        ar.sort()
        ar.push('All')
        ar.unshift('Past')
        ar.unshift('Current')
        return ar
      },
      listlength() {
        return this.fprofiles ? this.fprofiles.length : 0
      },
    },
    watch: {
      fltr(n, o) {
        this.Filter(n)
        this.activelist = undefined
        this.title = false
      },
      profiles(n, o) {
        this.Filter(this.fltr)
        if (n.length < 10) this.cardview = true
      },
      activelist(n) {
        if (n) {
          this.title = 'List updated on ' + new Date(n.updatedAt).toLocaleString()
          this.fprofiles = JSON.parse(n.data)
        } else {
          this.title = false
        }
      }
    },
    created() {
      this.fltr = window.localStorage.getItem('profilesfilter')
      if (!this.fltr) this.fltr = 'Current'
      this.listname = window.localStorage.getItem('athletelist')
    },
    mounted() {
      if (this.autorefreshmobile && this.$vuetify.breakpoint.smAndDown) {
        //sometimes on mobile data, page loads before loggedIn is set
        //leaving me with a blank players list..
        let em = this;
        setTimeout(function () {
          em.getMyAthletes()
        }, 1000)
      }
      if (!this.listname) this.listname = 'active'
      if (this.profiles) {
        this.Filter(this.fltr)
      }
      if (this.selectedprofiles) {
        let em = this
        this.selectedprofiles.forEach(f => {
          em.selected[f] = true
        })
        this.$forceUpdate()
      }
      if (this.profiles && this.profiles.length < 10) this.cardview = true
    },
    methods: {
      ...mapActions(['post', 'getMyAthletesArchived', 'getMyAthletes']),
      ...mapMutations(['setMyAthletes', 'setSelectedProfiles']),
      emitSelected(event) {
        if (this.creategroup) {
          if (this.selected.includes(event.partkey)) {
            let index = this.selected.findIndex(f => f === event.partkey)
            console.log(index)
            if (index < 0) return;
            this.selected.splice(index, 1)
          } else {
            this.selected.push(event.partkey)
            let tmp = new Set(this.selected)
            this.selected = [...tmp]
          }
        } else {
          this.$emit('player', event)
        }
      },
      async checkIn(playerkey) {
        let em = this
        let loc = await navigator.geolocation.getCurrentPosition(async function (l) {
          em.checkingin = playerkey
          let loc = l.coords.latitude + ',' + l.coords.longitude
          let p = await em.post({path: 'api/profilesv2/checkin', body: {playerkey: playerkey, location: loc}})
          em.checkingin = '000'
        })
      },
      Filter(e) {
        this.fltr = e
        if (!this.profiles) return
        if (this.profiles.length <= 5) {
          this.fltr = 'All'
        }
        let y = new Date().getUTCFullYear();
        window.localStorage.setItem('profilesfilter', e.toString())
        if (e === 'All') {
          this.fprofiles = this.profiles
          return
        } else if (e === 'Current') {
          this.fprofiles = this.profiles.filter(f => {
            return f.gradyear >= y
          })
          return
        } else if (e === 'Past') {
          this.fprofiles = this.profiles.filter(f => {
            return f.gradyear < y
          })
          return
        } else {
          this.fprofiles = this.profiles
        }
        this.fprofiles = this.profiles.filter(f => {
          return f.gradyear === parseInt(e)
        })
      },
      Sort(property) {
        //an example of how there are always trade-offs
        this.sorting = property
        let prop, dir
        let ln = this['sort' + property + 'array'].length
        this['sort' + property + 'index']++
        if (this['sort' + property + 'index'] === ln) {
          this['sort' + property + 'index'] = 0
        }
        prop = this['sort' + property + 'array'][this['sort' + property + 'index']][0]
        dir = this['sort' + property + 'array'][this['sort' + property + 'index']][1]
        console.log(property, prop, dir)
        let ar = Object.values(this.profiles)
        if (dir === true) { //asc
          ar.sort((a, b) => (a[prop] > b[prop]) ? 1 : -1)
          this.setFilterMessage('Sorted by ' + prop.toUpperCase() + '  ascending')
        } else if (dir === false) { //desc
          ar.sort((a, b) => (a[prop] < b[prop]) ? 1 : -1)
          this.setFilterMessage('Sorted by ' + prop.toUpperCase() + '  descending')
        } else {
          this.setFilterMessage('Not sorted')
        }
        this.setMyAthletes(ar)
      },
      async setActive(item) {
        let data = {
          playerkey: item.partkey,
          ownerkey: 'volleyforlife',
          active: item.active,
          archive: item.archive
        }
        let p = await this.put({path: 'api/profilesv2/setstatus/', body: data})
      },
      async searchAthletes() {
        let rsp = await this.post({path: 'api/profilesv2/findathelete', body: {search: this.search}})
        this.searched = rsp
      },
      setFilterMessage(m) {
        this.filtermessage = m
      },
      handleDone(event) {
        this.selected = []
        this.creategroup = false
      }
    }
  }
</script>

<style scoped>
    .active {
        background-color: #303F9F;
        color: #ffffff;
    }
</style>
